export default __webpack_public_path__ + "static/media/Total_Demo_Blurred_01.9c0e9ef1.png";